import { IS_NATIVE } from "../config/platform";

// KÜLSŐ LINK MEGNYITÁSA — egyetlen közös út, web és natív.
//
// Miért van ez a fájl (2026-09-15, ClickUp 123qmzqyahe): a `target="_blank"`
// a Capacitor WKWebView-ban NÉMA NO-OP — nincs mögötte ablaknyitó delegate,
// ezért a link egyszerűen nem reagál a koppintásra. Weben ugyanez működik,
// ezért hónapokig nem bukott ki. A natív QA B10/B11 tétele találta meg: a
// regisztrációs képernyő két jogi linkje nem volt megnyitható — ami az Apple
// szemében önálló elutasítási ok (elérhető adatvédelmi tájékoztató).
//
// A `build.sh:84` guard nem fogta meg, mert az a CÉLPONTOT ellenőrzi (bent
// van-e a HTML a natív bundle-ben), nem az UTAT.

/** A publikus origó — natívon ide oldjuk fel a relatív útvonalakat. */
export const PUBLIC_ORIGIN = "https://glpnaplo.hu";

/**
 * A ténylegesen megnyitandó URL.
 *
 * Natívon a webview origója `capacitor://localhost` (nincs `server`
 * beállítás a capacitor.config.ts-ben, tehát az alapértelmezés él). Egy
 * in-app Safari nézet ezt a sémát NEM tudja betölteni, ezért a relatív
 * útvonalat a publikus origóra oldjuk fel.
 *
 * ⚠️ Következmény: a jogi lapok natívon a WEBRŐL nyílnak meg, nem a
 * bundle-ből — offline tehát nem érhetők el. A bundle-ben maradó példányuk
 * (build.sh `required` lista) ettől még nem felesleges: az a garancia, hogy
 * a lapok egyáltalán léteznek, és tartalék, ha valaha visszatérnénk a helyi
 * kiszolgáláshoz.
 *
 * Abszolút URL-t (http/https) érintetlenül hagyunk — a Ko-fi és a gyártói
 * forrás-hivatkozások ilyenek.
 */
export function resolveExternalUrl(url: string, isNative: boolean): string {
  if (!isNative) return url;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;
  return `${PUBLIC_ORIGIN}${url.startsWith("/") ? "" : "/"}${url}`;
}

/**
 * Külső link megnyitása. Natívon in-app Safari nézetben („Kész" gombbal,
 * utána visszatérés az appba), weben új fülön.
 *
 * A `@capacitor/browser` importja SZÁNDÉKOSAN dinamikus, a
 * `usePdfRiport.tsx` `@capacitor/share` mintája szerint — így a webes
 * bundle-be nem kerül bele.
 */
export async function openExternal(url: string): Promise<void> {
  const target = resolveExternalUrl(url, IS_NATIVE);

  if (!IS_NATIVE) {
    window.open(target, "_blank", "noopener,noreferrer");
    return;
  }

  const { Browser } = await import("@capacitor/browser");
  await Browser.open({ url: target });
}
